export default "__VITE_ASSET__CI$e7ivD__"